// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"266":"5ebd1fdd","651":"60e25258"}[chunkId] + ".chunk.js";
};